"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    props: {
        blocks: {
            type: Array,
            default: null,
        },
        class: {
            type: [Object, String],
            default: null,
        },
    },
    computed: {
        itemClass: function () {
            return this.class || '';
        },
    },
    template: '<block-container v-for="block in blocks" :key="block.systemId" :class="itemClass" :block="block"/>',
};
//# sourceMappingURL=blocks-repeater.js.map